import { render } from "./CloseBtn.vue?vue&type=template&id=3397fbc9&ts=true"
import script from "./CloseBtn.vue?vue&type=script&lang=ts"
export * from "./CloseBtn.vue?vue&type=script&lang=ts"

import "./CloseBtn.vue?vue&type=style&index=0&id=3397fbc9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__